jQuery(document).ready(function ($) {
    $(".back-top button").on('click', function (e) {
        e.preventDefault()

        $('html, body').animate({
            scrollTop: 0
        }, 250)
    })
});